export default {
    setActiveLanguages(state, payload) {
        state.activeLanguageList = payload
    },
    setTranslatedText(state,payload){
        state.translatedText = payload;
    },
    setIdentifyedLanguage(state,payload){
        state.identifyedLanguage = payload;
    }
}